export function generatePastelColorForHash(hash) {
  if (!hash) {
    return '';
  }
  // Use a golden-ratio-based hue sequence to keep successive hashes visually far apart
  // even when their numeric seeds are close.
  let value = 0;
  for (let i = 0; i < hash.length; i += 1) {
    value = ((value * 31) + hash.charCodeAt(i)) >>> 0;
  }
  const goldenRatioConjugate = 0.618033988749895;
  const hue = ((value * goldenRatioConjugate) % 1) * 360;
  const saturation = 55 + (value % 15);
  const lightness = 75 + (value % 10);
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}

export function hslWithAlpha(color, alpha = 1) {
  if (!color || typeof color !== 'string') {
    return color;
  }
  if (!color.trim().toLowerCase().startsWith('hsl(')) {
    return color;
  }
  const normalizedAlpha = Math.min(Math.max(alpha, 0), 1);
  return color
    .replace(/^hsl/, 'hsla')
    .replace(/\)$/, `, ${normalizedAlpha})`);
}
